<script>
import { getRouteByPath } from '@/utils/helpers';
import routesConfig from '@/routes.config';
import MenuItem from './MenuItem';


export default {
  data() {
    return {
      openKeys: [],
    };
  },
  props: {
    routes: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  components: {
    MenuItem,
  },
  mounted() {
    this.setOpenKeys(this.$route.path);
  },
  
  watch: {
    '$route.path': function (newVal) { // eslint-disable-line
      this.setOpenKeys(newVal);
    },
  },
  methods: {
    setOpenKeys(path) {
      const route = getRouteByPath(path, routesConfig);
      const { parents = [] } = route || {};
      const generateOpenkeys = () => {
        this.openKeys.push(...parents.map(p => p.path).filter(p => !this.openKeys.includes(p)));
      };
      if (parents && parents.length > 0) {
        generateOpenkeys();
      }
    },
    generateMenuItems(routes) {
      if (!routes) {
        return [];
      }
      return routes
        .filter(r => !r.standalone)
        .map((r) => {
          if (r.routes && r.routes.length > 0) {
            return (
              <a-sub-menu
                key={r.path}
                title={<MenuItem item={r}></MenuItem>}
                onTitleClick={(item) => {
                  const index = this.openKeys.findIndex(k => k === item.key);
                  if (index !== -1) {
                    this.openKeys.splice(index, 1);
                  } else {
                    this.openKeys.push(item.key);
                  }
                }}
              >
                {this.generateMenuItems(r.routes)}
              </a-sub-menu>
            );
          }
          return (
            <a-menu-item
              key={r.path}
              onClick={() => {
                document.getElementsByClassName('main-content')[0].scrollTo(0, 0);
                if (this.$route.path !== r.path) {
                  this.$router.push(r.path);
                }
              }}
            >
              <MenuItem item={r}></MenuItem>
            </a-menu-item>
          );
        });
    },
  },
  render() {
    return (
      <a-menu mode="inline" selectedKeys={[this.$route.path]} openKeys={this.openKeys}>
        {this.generateMenuItems(this.routes)}
      </a-menu>
    );
  },
};
</script>
